<template>
    <div class="d-flex align-items-center justify-content-end">
        <CheckBoxComponent
            :id="id"
            class="me-3"
            :data-bs-toggle="!isChecked ? 'modal' : ''"
            :data-bs-target="`#${id}-modal`"
            :state="isChecked" 
            @change="setChecked($event)"/>

        <label :for="id" class="additional-info-label-text">
            {{ labelText }} {{ (address.length > 0) ? `(${address})` : '' }}
        </label>

        <ModalComponent :show-title="false" :id-data="`${id}-modal`">
            <template #body-content>
                <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="font-weight-600 p-3">{{ upperText }}</h5>
                <div class="font-big mb-4 font-weight-400 form-sub-title">{{ lowerText }}</div>
                <div class="w-100">
                    <div class="d-flex flex-column w-100">
                        <VueGoogleAutocomplete
                            classname="form-control"
                            country="lt"
                            types=""
                            ref="address"
                            :placeholder="$t('address')"
                            :id="`${id}-input`"

                            @placechanged="setAddressData">
                        </VueGoogleAutocomplete>

                        <textarea :placeholder="$t('comment')" class="form-text-area-input mb-4" v-model="note"></textarea>
                    </div>
                </div>
                </div>
            </template>
        </ModalComponent>
    </div>
</template>
  
<script lang="ts">
import {defineComponent} from "vue";
// @ts-ignore
import CheckBoxComponent from "../../components/CheckBox/CheckBoxComponent.vue";
// @ts-ignore
import ModalComponent from "../../components/modal/ModalComponent.vue";
// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";
// @ts-ignore
import VueGoogleAutocomplete from "../../../js/plugins/vue-google-autocomplete/src/VueGoogleAutocomplete.vue";
import debounce from 'lodash.debounce'

export default defineComponent({
    name: 'TripAdditionalInfoCheckboxModalComponent',
    components: {
        CheckBoxComponent,
        ModalComponent,
        ButtonComponent,
        VueGoogleAutocomplete,
    },
    emits: ['changedAddress', 'changedNote'],

    computed: {
        //
    },

    props: {
        id: {
            type: String,
            required: true
        },
        labelText: {
            type: String,
            required: true
        },
        upperText: {
            type: String,
            required: true
        },
        lowerText: {
            type: String,
            required: true
        },
        init_is_checked: {
            type: Boolean,
            required: true
        },
        init_address: {
            type: String,
            required: true
        },
        init_note: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            isChecked: this.init_is_checked,
            address: this.init_address,
            note: this.init_note,
        }
    },

    watch: {
        note(newVal, oldVal) {
                this.setNote(newVal);
            }
    },

    methods: {
        setChecked($event: {target: HTMLInputElement}): void {
            this.isChecked = $event.target.checked;
            if(!this.isChecked) {
                this.$emit('changedAddress', {id: this.id, value: ""});
                this.$emit('changedNote', {id: this.id, value: ""});
            }
            if(this.isChecked && (this.address.length > 0 || this.note.length > 0)) {
                this.$emit('changedAddress', {id: this.id, value: this.address});
                this.$emit('changedNote', {id: this.id, value: this.note});
            }
        },

        /**
         * When the location found
         * @param {Object} addressData Data of the found location
         * @param {Object} placeResultData PlaceResult object
         * @param {String} id Input container ID
         */
        setAddressData: function (addressData: any, placeResultData: any, id: string): void {
            this.address = this.formatAddress(addressData);
            this.$emit('changedAddress', {id: this.id, value: this.formatAddress(addressData)});
        },

        setNote: debounce(function(this: any, newVal: string) {
            this.$emit('changedNote', {id: this.id, value: newVal});
        }, 1000),

        
        formatAddress: function (payload) {
            if (! payload) {
                // @ts-ignore
                return this.$refs.address.autocompleteText = "";
            }
            let str = '';

            if (payload.raw) {
                const raw = payload.raw;
                str += raw.formatted_address;

                if (raw.formatted_address.indexOf(raw.name) < 0) {
                str = raw.name + ', ' + str;
                }
            }
            // @ts-ignore
            return str;
        },

    },

    mounted() {
        let modal = document.querySelector('#' + this.id + '-modal');
        let modalDialog = modal!.querySelector('.modal-dialog');
        let header = modal!.querySelector('.modal-header');
        header!.classList.add('d-flex');
        header!.classList.add('justify-content-center');
        header!.classList.add('modal-header-border');
        modalDialog!.classList.remove('modal-xl');
        // @ts-ignore
        this.$refs.address.update(this.address);
    }
})
</script>

<style scoped lang="scss">
@import './tripAdditionalInfoCheckboxModal.scss';
</style>